import theme from "@/theme";

export const styles = {
  trendingWrapper: {
    maxWidth: 340,
    position: "relative",
    // height: 526,
    bgcolor: "#F7F9FB",
    borderRadius: "15px",
    padding: "12px 20px 12px 16px",
    gap: 10,
    opacity: 1,
    transform: "rotate(0deg)",
    boxSizing: "border-box",
  },
  toggleButtonGroup: {
    minWidth: "105px",
    height: "20px",
    gap: "16px",
  },

  toggleButton: {
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
    color: "#939393",
    backgroundColor: "transparent !important",
    border: "none !important",
    padding: 0,
    minWidth: 0,
    minHeight: 0,
    boxShadow: "none !important",
    whiteSpace: "nowrap",
    textTransform: "none",
    cursor: "pointer",

    "&.Mui-selected": {
      backgroundColor: "transparent !important",
      color: "#000000",
      border: "none !important",
    },

    "&.Mui-disabled": {
      color: "#939393",
      border: "none !important",
      backgroundColor: "transparent !important",
      opacity: 1,
    },

    "&.Mui-disabled.Mui-selected": {
      border: "none !important",
      backgroundColor: "transparent !important",
      boxShadow: "none !important",
    },

    "&:hover": {
      backgroundColor: "transparent !important",
    },

    "&.Mui-focusVisible": {
      outline: "none",
      border: "none",
    },
  },

  toggleButtonTooltip: {
    color: theme.palette.custom.mainWhite,
    textDecoration: "underline",
    textTransform: "none",
    padding: 0,
  },
  tabsNavigation: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    minHeight: "24px",
    height: "24px",
    "& .MuiTabs-flexContainer": {
      alignItems: "center",
      justifyContent: "space-between",
    },
    "& .MuiTabs-scroller": {
      margin: 0,
    },
  },

  tabsNavigationIndicator: {
    backgroundColor: theme.palette.custom.mainBlue,
    height: "2px",
    borderRadius: 2,
    bottom: 0,
  },

  tabsNavigationTab: (activeTab: string, tabValue: string) => ({
    minHeight: "24px",
    height: "24px",
    minWidth: "auto",
    padding: "0",
    lineHeight: "24px",
    textTransform: "none",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: activeTab === tabValue ? 600 : 500,
    color: activeTab === tabValue ? theme.palette.custom.blueGray900 : "#939393",
    display: "flex",
    alignItems: "center",
    margin: 0,
  }),

  tableContainer: {
    minHeight: "202px",
    borderRadius: "12px",
    width: "100%",
    overflowX: "hidden",
  },
  tableBodyBox: {
    display: "flex",
    alignItems: "center",
    gap: "0.25rem",
    top: "70%",
    left: "50%",
    zIndex: 5,
    transform: "translate(-50%, -50%)",
  },
  tableBody: {
    "& .MuiTableRow-root .MuiTableCell-root": {
      padding: "8px 0px",
    },
    position: "relative",
    overflowX: "hidden",
  },
  tableCell: (premium: boolean, index: number, length: number) => {
    let borderBottom = "1px solid #F4F5F6";

    if (!premium && index >= 2) borderBottom = "none";
    if (index === length - 1) borderBottom = "none";

    return {
      borderBottom,
    };
  },
  filtersWrapper: {
    width: "304px",
    maxHeight: "36px",
    display: "flex",
    justifyContent: "space-between",
    gap: "16px",
    marginBottom: "16px",
  },

  filterSelect: {
    width: "142px",
    height: "40px",
    borderRadius: "12px",
    bgcolor: "#F7F9FB",
    padding: "8px 16px",
    fontFamily: "Inter",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "24px",
    letterSpacing: "0%",
    color: theme.palette.custom.blueGray500,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSelect-icon": {
      color: theme.palette.custom.blueGray500,
    },
    "& .MuiSelect-select": {
      padding: "0px !important",
    },
  },
  sortTabsContainer: {
    width: "100%",
    maxHeight: "20px",
    marginBottom: "24px",
  },

  tabs: {
    minHeight: "auto",
    borderBottom: "1px solid #E1E4E8",
  },

  tabsIndicator: {
    height: "2px",
    borderRadius: "2px",
    backgroundColor: "#1B1C1E",
  },

  tab: (activeTab: string, tabValue: string) => ({
    minWidth: 0,
    minHeight: 0,
    textTransform: "none",
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: activeTab === tabValue ? 600 : 500,
    color:
      activeTab === tabValue ? theme.palette.custom.blueGray900 : theme.palette.custom.blueGray600,
    padding: "0 16px",
  }),

  sortTabs: {
    minWidth: "304px",
    minHeight: "auto",
    borderBottom: "1px solid #E1E4E8",
    "& .MuiTabs-flexContainer": {
      justifyContent: "space-between",
    },
  },

  sortTabsIndicator: {
    height: "3px",
    borderRadius: "2px",
    backgroundColor: "#1B1C1E",
  },

  sortTabsTab: (activeTab: string, tabValue: string) => ({
    minWidth: "auto",
    minHeight: "24px",
    textTransform: "none",
    fontFamily: "Inter",
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: activeTab === tabValue ? 600 : 500,
    color: activeTab === tabValue ? "#2A2D31" : "#7D8690",
    padding: "0 2px",
    "&.Mui-selected": {
      color: "#2A2D31",
    },
    "&.MuiTab-root": {
      color: "#7D8690",
    },
  }),
};
